import { useTheme } from '../../hooks/useTheme';
import { toast } from 'react-toastify';
import i18n from '../../i18n/i18n';

// Components
import DeleteSlotBadge from '../DeleteSlotBadge';

// MUI imports
import { Box, Typography } from '@mui/material';

// Helpers
import { useSessionStore } from '../../store/SessionStore';
import { SlotDayData, SlotData } from '../../types/slotData';
import { deleteBatchSlot } from '../../helpers/api/callSlot';

interface SlotProps {
    slot: SlotDayData;
    isSelected: boolean;
    editMode: boolean;
    onClick: () => void;
}

const Slot = ({ slot, isSelected, onClick, editMode }: SlotProps) => {
    const theme = useTheme();
    const { reloadSession } = useSessionStore();

    const handleDeleteSlotBatch = async (slot: SlotDayData) => {
        let slotsToDelete: SlotData[] = [];
        if (slot.firstPeriod && slot.secondPeriod) {
            slotsToDelete = [slot.firstPeriod, slot.secondPeriod];
        }
        try {
            const response = await deleteBatchSlot(slotsToDelete);

            if (response.code === 400) {
                toast.error(i18n.t('UpdateSession.errors.deleteBatchSlot'));
            }

            toast.success(i18n.t('UpdateSession.success.deleteBatchSlot'));
            reloadSession();
        } catch (error) {
            console.error('Error deleting slot:', error);
            toast.error(i18n.t('UpdateSession.errors.deleteBatchSlot'));
        }
    };

    const slotBox = (
        <Box
            onClick={onClick}
            sx={{
                padding: '4px 0 2px 0',
                marginTop: '0.75em',
                mb: '0.4em',
                borderRadius: '5px',
                width: '45px',
                cursor: 'pointer',
                backgroundColor: isSelected ? theme.palette.text.custom : theme.palette.background.default,
                color: isSelected ? theme.palette.background.default : theme.palette.primary.main,
                boxShadow: isSelected ? '0px 3px 7px 0px rgba(0,0,0,0.25)' : 'none',
                position: 'relative'
            }}
        >
            <Typography sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '0.85rem' }}>{slot.dayName}</Typography>
            <Typography sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.15rem' }}>{slot.dayNumber}</Typography>
        </Box>
    );

    if (editMode && isSelected) {
        return (
            <DeleteSlotBadge
                onCloseClick={(e) => {
                    e.stopPropagation();
                    handleDeleteSlotBatch(slot);
                }}
            >
                {slotBox}
            </DeleteSlotBadge>
        );
    }

    return slotBox;
};

export default Slot;
